/**
 * Desc:
 * Created Date: Tuesday, September 10th 2024, 6:39:46 pm
 * Author: jim Li
 * -----
 * Last Modified: Tue May 20 2025
 * Modified By: jim Li
 */

export default {
  Title_Common: {
    TiShi: 'Tips',
    DianZiCheng_SheDing: 'Electronic Scale Settings',
    YaoPingZhongLiang: 'Weight',
    KaiShiZhi: 'Start',
    JieShuZhi: 'End',
    WuCha: 'Error',
    AnZhaoBiLiJiSuan: 'Calculate',
    NONG_S_System: "Nong's System",
    Guige_Biaozhun: 'Standard',
    Gonggong_Shuju: 'Public Data',
    Zidian_Guanli: 'Dictionary',
    HaoYuan_GuiZe: 'Source Rules',
    GuanLi_XiTong: '',
    ShouYe: 'Home',
    ZhenSuo_GuanLi: 'Clinic',
    YuanGong_GuanLi: 'Clinic Employee',
    XinZeng_YuanGong_XinXi: 'Add employee',
    XiuGai_YuanGong_XinXi: 'Edit employee',
    YuanGong_XinXi: 'Employee info',
    QueRen_ChongZhi_MiMa: 'Confirm reset password',
    JueSe_QuanXian: 'Clinic Role',
    ZhenSuo_PeiZhi: 'Clinic config',
    YouHuiQuan: 'Clinic coupon',
    YongHu_GuanLi: 'User',
    HuanZhe_GuanLi: 'Patient Management',
    BiaoQian_LieBiao: 'Tag List',
    ZhuanJieMa: 'Promotion',
    YaoPin_GuanLi: 'Medicine',
    YaoPin_LieBiao: 'Medicine list',
    CaiGou_PanDian: 'Lack Inventory',
    YaoPin_CaiGou: 'Purchase Record',
    YaoPin_PanDian: 'Inventory Adjustment',
    XiangMu_GuanLi: 'Project',
    ZhenJiu_GuanLi: 'Acupuncture Management',
    TuiNa_ZhengGu: 'Massage/Boning',
    BaGuan_GuanLi: 'Boning Management',
    PiPei_YaoWu: 'Matching Medicine',
    ShangDian_LingShou: 'Store Retail',
    TaoPiao_GuanLi: 'Ticket Management',
    ShangPin_GuanLi: 'Product Management',
    ChaXun_TongJi: 'Statistics',
    KeYuan_YingShou: 'Customer Revenue',
    YaoPin_ShiYong_ChengBen_BaoGao: 'Medicine Use',
    DuiZhang_Dan: 'Statement Account',
    DanJu_MingXi_WangJiao: 'Record Details',
    ZhongYi_ZhenSuo: 'Chinese Medicine Clinic',
    Zhong: 'Clinic',
    ZhenSuo_Duan: 'Clinic',
    GuanLi_Duan: 'Management',
    PeiSong_SheDing: 'Delivery',
    ZhiFu_SheDing: 'Payment',
    PeiYao_SheDing: 'Medicine',
    YongHu_XinXi: 'User info',
    XinZeng_YouHuiQuan_XinXi: 'Add coupon',
    XiuGai_YouHuiQuan_XinXi: 'Edit coupon',
    YouHuiQuan_XinXi: 'Coupon',
    QueRen_QiYong: 'Confirm enable',
    QueRen_TingYong: 'Confirm out of ',
    BingRen_ZiLiao: 'Patient',
    XinZeng_BingRen_ZiLiao: 'Add patient',
    BianJi_BingRen_ZiLiao: 'Edit patient',
    ZhengZai_ShanChu_YongHu: 'Deleting a user',
    TaoCan_GuanLi: 'Tag Management',
    XinZeng_TaoCan: 'Add tag',
    ZhenSuo_SheDing: 'Clinic',
    PeiSong_DiZhi: 'Address',
    TianJia_ShouHuo_DiZhi: 'Add address',
    BianJi_ShouHuo_DiZhi: 'Edit address',
    YaoPin_MingXi: 'Medicant detail',
    DingDan_XiangQing: 'Order details',
    QianShou_YaoPin: 'Sign drugs',
    DingDan_ShenHe: 'Order review',
    CaiGou_DingDan: 'Purchase order',
    DingDan_QianShou: 'Order signing',
    YaoPin_XuanZe: 'Drug selection',
    KuCun_TiaoZheng: 'Inventory adjustment',
    ChuZhi_Ka: 'Prepaid card',
    YouHui_GuanLi: 'Discount management',
    XinZeng_ChuZhiKa_XinXi: 'Add',
    BianJi_ChuZhiKa_XinXi: 'Edit',
    ChuZhiKa_XinXi: 'Info',
    QianMing: 'Signature',
    PanDian_XiangQing: 'Check detail',
    PanDian_YuLan: 'Preview',
    XiTong_ShouYe: 'Home',
    ZhiFu_SheZhi: 'Pay',
    PeiYao_SheZhi: 'Dispensing',
    ShouFei_SheZhi: 'Charge',
    ShouFei_XiangMu: 'Project',
    DaYin: 'Print',
    DaYin_SheZhi: 'Print',
    ShouFei_Zu: 'Group',
    ChuZhi_HuoDong: 'Events',
    HuoDong_XinXi: 'Info',
    ChuZhi_YongHu: 'Client',
    ChangYong_SheDing: 'Common',
    ChangYong_ChuFang: 'Prescription',
    ChangYong_XueWei: 'Acupuncture',
    ChangYong_FenLei: 'Classifications',
    FenLei_ChuFang_Dan: 'Prescription',
    ChuFang_Dan_NeiRong: 'Content',
    FenLei_XueWei_Dan: 'Acupuncture',
    XueWei_Dan_NeiRong: 'Content',
    BianHao_SheZhi: 'Number',
    XinZeng_XiangMu: 'Add setmeal',
    XiuGai_XiangMu: 'Edit setmeal',
    XinZeng_TaoPiao_XinXi: 'Add setmeal',
    XiuGai_TaoPiao_XinXi: 'Edit setmeal',
    TaoPiao_XinXi: 'Setmeal',
    ZhenZhi_SheZhi: 'Diagnosis',
    ZhenDuan_ZiLiao_SheDing: 'Diagnostic Data Settings',
    DaYin_JiLu: 'Print Record',
    PaiBan_SheZhi: 'Schedule',
    DiTu: 'Map',
    JiGou_GuanLi: 'Organization',
    RenYuan_GuanLi: 'Personnel',
    ShouQuan_GuanLi: 'Proxy',
    XiTong_GuanLi: 'System',
    JieXi_GuanLi: 'Domain',
    XiaoXi_TongZhi: 'Message',
    TuiSong_MuBan: 'Template',
    DiSanFang: 'Thirdparty',
    MiYao_GuanLi: 'Authorize',
    XinZeng_YaoPin_GuiGe: 'Add Drug Specification',
    XiuGai_YaoPin_GuiGe: 'Edit Drug Specification',
    YaoPin_PiCi: 'Drug Batch',
    XinZeng_YaoPin_PiCi: 'Add Batch',
    XiuGai_YaoPin_PiCi: 'Edit Batch',
  },
}
